export function getMaintenanceDateRange(
  dateFilter: string,
  customStart?: Date | null,
  customEnd?: Date | null,
  referenceDate: Date = new Date()
): { start: Date; end: Date } | null {
  const today = new Date(referenceDate);
  today.setHours(0, 0, 0, 0);
  const todayEnd = new Date(referenceDate);
  todayEnd.setHours(23, 59, 59, 999);

  switch (dateFilter) {
    case 'CUSTOM':
      if (!customStart || !customEnd) {
        return null;
      }
      return { start: new Date(customStart), end: new Date(customEnd) };

    case 'LAST_7_DAYS': {
      const start = new Date(today);
      start.setDate(start.getDate() - 6);
      return { start, end: todayEnd };
    }

    case 'NEXT_7_DAYS': {
      const end = new Date(todayEnd);
      end.setDate(end.getDate() + 6);
      return { start: today, end };
    }

    case 'LAST_MONTH': {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999);
      return { start, end };
    }

    case 'NEXT_MONTH': {
      const start = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth() + 2, 0, 23, 59, 59, 999);
      return { start, end };
    }

    case 'NEXT_3_MONTH': {
      const start = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth() + 4, 0, 23, 59, 59, 999);
      return { start, end };
    }

    case 'THIS_MONTH': {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59, 999);
      return { start, end };
    }

    case 'LAST_QUARTER': {
      const currentQuarter = Math.floor(today.getMonth() / 3);
      const year = currentQuarter === 0 ? today.getFullYear() - 1 : today.getFullYear();
      const quarter = currentQuarter === 0 ? 3 : currentQuarter - 1;
      const startMonth = quarter * 3;
      const start = new Date(year, startMonth, 1);
      const end = new Date(year, startMonth + 3, 0, 23, 59, 59, 999);
      return { start, end };
    }

    case 'NEXT_QUARTER': {
      const currentQuarter = Math.floor(today.getMonth() / 3);
      const year = currentQuarter === 3 ? today.getFullYear() + 1 : today.getFullYear();
      const quarter = currentQuarter === 3 ? 0 : currentQuarter + 1;
      const startMonth = quarter * 3;
      const start = new Date(year, startMonth, 1);
      const end = new Date(year, startMonth + 3, 0, 23, 59, 59, 999);
      return { start, end };
    }

    case 'LAST_YEAR': {
      const year = today.getFullYear() - 1;
      return {
        start: new Date(year, 0, 1),
        end: new Date(year, 11, 31, 23, 59, 59, 999),
      };
    }

    case 'NEXT_YEAR': {
      const year = today.getFullYear() + 1;
      return {
        start: new Date(year, 0, 1),
        end: new Date(year, 11, 31, 23, 59, 59, 999),
      };
    }

    default:
      return null;
  }
}

export function formatMaintenanceDateTime(date: Date, endOfDay = false): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return endOfDay ? `${y}-${m}-${d}T23:59:59Z` : `${y}-${m}-${d}T00:00:00Z`;
}

export function formatMaintenanceDisplayDate(date: Date): string {
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
